import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { Bot, Lightbulb, Play } from 'lucide-react';
import Sidebar from './Sidebar';
import AgentTabNav from './AgentTabNav';
import api from '../services/api';

const AgentLayout = ({ children }) => {
  const [stats, setStats] = useState(null);
  const navigate = useNavigate();

  const fetchStats = useCallback(async () => {
    try {
      const res = await api.get('/admin/trados-agent/stats');
      setStats(res.data);
    } catch (err) { console.error('Failed to fetch agent stats:', err); }
  }, []);

  useEffect(() => { fetchStats(); }, [fetchStats]);

  return (
    <Sidebar>
      <div className="p-6 md:p-8 bg-gray-50/50 min-h-screen">
        {/* Header */}
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-indigo-500 to-purple-600 flex items-center justify-center shadow-lg">
              <Bot className="w-7 h-7 text-white" />
            </div>
            <div>
              <h1 className="text-2xl font-bold text-gray-900">Trados Agent</h1>
              <p className="text-sm text-gray-500">AI operations assistant</p>
            </div>
          </div>
          {stats && (
            <div className="hidden md:flex items-center gap-4 text-sm">
              {stats.suggestions.pending_review > 0 && (
                <button onClick={() => navigate('/admin/trados-agent/suggestions?status=pending_review')}
                  className="flex items-center gap-1.5 px-3 py-1.5 bg-amber-50 text-amber-700 rounded-full border border-amber-200 hover:bg-amber-100 transition-colors">
                  <Lightbulb className="w-4 h-4" />
                  {stats.suggestions.pending_review} pending
                </button>
              )}
              {stats.tasks.running > 0 && (
                <span className="flex items-center gap-1.5 px-3 py-1.5 bg-blue-50 text-blue-700 rounded-full border border-blue-200">
                  <Play className="w-4 h-4" />
                  {stats.tasks.running} running
                </span>
              )}
            </div>
          )}
        </div>

        <AgentTabNav stats={stats} />

        {typeof children === 'function' ? children({ stats, refreshStats: fetchStats }) : children}
      </div>
    </Sidebar>
  );
};

export default AgentLayout;
